
export default {
    data() {
        return {
            errors: []
        };
    },
    methods: {
        trackError: function (e, context, message) {
            if (e.message && e.message.constructor && e.message.constructor.name === 'Cancel') {
                return;
            }
            if (e.response) {
                if (e.response.data) {
                    let data = e.response.data;
                    message += ' Server error';
                    if (data.message) {
                        message += ': ' + data.message;
                    }
                    if (data.error && data.error.message) {
                        message += ': ' + data.error.message;
                    }
                }
                if (e.response.status) {
                    e.code = e.response.status;
                }
            }
            if (e.message) {
                message += ': ' + e.message;
            }

            if (_.isUndefined(context)) {
                context = null;
            }
            if (_.isUndefined(message)) {
                message = false;
            }
            console.trace(e);
            let row = {
                error: e,
                type: 'error',
                context: context,
                message: message,
            };

            if (this.errors) {
                this.errors.push(row);
            } else {
                if (this.$parent && this.$parent.errors) {
                    this.$parent.errors.push(row);
                }
            }
            if (message) {
                console.log('tracked error', row);
            }
            if (this.$store) {
                this.$store.commit('add_message', row);
            } else {
                let errorMessage = row.message;
                if (!errorMessage) {
                    errorMessage = e.message;
                }
                console.log('error message', errorMessage);
                //alert(errorMessage);
            }
        },
        adminAlert: function (message, type) {
            let row = {
                type: type,
                message: message,
            };
            if (this.errors) {
                this.errors.push(row);
            }
            if (message) {
                console.log('tracked error', row);
            }
            if (this.$store) {
                this.$store.commit('add_message', row);
            } else {
                let errorMessage = row.message;

            }
        }
    }
}
